var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/api/agent/schema/agents.zod.ts
import { z } from "zod";
var fullNameSchema = z.string().min(2, "Name must be at least 2 characters");
var mobileSchema = z.string().length(10, "Mobile must be exactly 10 digits").regex(/^\d+$/, "Must be digits only");
var emailSchema = z.string().email("Invalid email").optional().or(z.literal("")).nullable();
var orgUnitIdSchema = z.string().uuid();
var supervisorIdSchema = z.string().uuid().optional().or(z.literal("")).nullable();
var employmentTypeEnum = z.enum([
  "FULL_TIME",
  "PART_TIME",
  "CONTRACT"
]);
var joinedAtSchema = z.coerce.date();
var roleIdSchema = z.string().uuid();
var CreateSchema = z.object({
  fullName: fullNameSchema,
  mobile: mobileSchema,
  email: emailSchema,
  orgUnitId: orgUnitIdSchema,
  roleId: roleIdSchema,
  supervisorId: supervisorIdSchema,
  employmentType: employmentTypeEnum.default("FULL_TIME"),
  joinedAt: joinedAtSchema
});
var UpdateSchema = CreateSchema.partial();
var ResponseSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  userId: z.string().uuid(),
  agentNumber: z.string(),
  fullName: fullNameSchema,
  mobile: mobileSchema,
  email: z.string().email("Invalid email").nullable().or(z.literal("")),
  orgUnitId: orgUnitIdSchema,
  supervisorId: z.string().uuid().nullable(),
  status: z.enum([
    "ACTIVE",
    "SUSPENDED",
    "TERMINATED"
  ]),
  suspensionReason: z.string().nullable(),
  employmentType: employmentTypeEnum,
  joinedAt: z.string(),
  terminatedAt: z.string().nullable(),
  createdBy: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  deletedAt: z.string().nullable()
});

export {
  __name,
  CreateSchema,
  UpdateSchema,
  ResponseSchema
};
//# sourceMappingURL=chunk-YZR3XMWZ.js.map